import getEnv from 'utils/getEnv';

const getMediaUrl = mediaFile => {
  return getEnv('REACT_APP_MEDIA_ROOT_URL') + mediaFile;
};

export default getMediaUrl;
